import { JSX } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import UploadFile from '@mui/icons-material/UploadFile';

const FILE_UPLOAD_NOTICE =
  'Answers marked with this icon will require you to upload supporting documentation.';

interface Props {
  show: boolean;
}

export default function FileUploadNotice({ show }: Props): JSX.Element | null {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (!show) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: isDark ? 'info.dark' : 'info.lighter',
        border: '1px solid',
        borderColor: isDark ? 'info.dark' : 'info.light',
        borderRadius: '10px',
        px: 1.5,
        py: 1.25,
        mt: 1,
      }}
    >
      <UploadFile
        sx={{
          fontSize: 24,
          color: isDark ? 'info.lighter' : 'info.dark',
        }}
      />
      <Typography
        sx={{
          fontSize: 13,
          color: isDark ? 'common.white' : 'grey.800',
          lineHeight: 1.5,
        }}
      >
        {FILE_UPLOAD_NOTICE}
      </Typography>
    </Box>
  );
}
